<template>
  <v-container>
    <v-card class="pa-4" color="red" v-if="errorMessage">
      <v-card-title>ОШИБКА</v-card-title>
      <v-card-text>{{ errorMessage }}</v-card-text>
    </v-card>
    <v-form>
      <v-select label="Тип счетчика" v-model="counter.type" :items="counterTypes"/>
      <v-text-field label="Местонахождения" v-model="counter.title" required/>
      <v-text-field label="Серийный номер" v-model="counter.number" required/>
      <v-switch label="Активный?" v-model="counter.isActive"/>
      <v-btn class="mr-4 mb-4" @click="saveChanges">Сохранить</v-btn>
      <v-btn class="mr-4 mb-4" @click="cancelChanges">Отменить</v-btn>
      <v-btn class="mr-4 mb-4" @click.stop="confirmation = true" v-if="counter.id">Удалить</v-btn>
      <v-dialog v-model="confirmation" persistent width="290" @keydown.esc="cancelDeletion">
        <v-card>
          <v-toolbar dark dense flat>
            <v-icon>mdi-alert-outline</v-icon>
            <v-toolbar-title class="white--text">Удаление</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4">Вы действительно желаете удалить счётчик и всю связанную с ним информацию?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="confirmDeletion">Удалить</v-btn>
            <v-btn @click="cancelDeletion">Отменить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-container>

</template>

<script>
export default {
  name: 'CounterEdit',
  props: {
    counterId: String
  },
  data() {
    return {
      errorMessage: null,
      confirmation: false,
      valid: false,
      counterTypes: [
        {value: "WATER_HOT", text: "Горячая вода"},
        {value: "WATER_COLD", text: "Холодная вода"},
        {value: "ELECTRO_1", text: "Электричество (1 тариф)"},
        {value: "ELECTRO_2", text: "Электричество (2 тарифа)"},
        {value: "ELECTRO_3", text: "Электричество (3 тарифа)"},
      ],
      counter: {
        id: null,
        title: null,
        type: null,
        number: null,
        isActive: true
      }
    }
  },
  mounted() {
    const counterId = this.counterId
    console.log(`CounterEdit ${counterId}`)
    if (counterId) {
      this.$http.get(`/counter/${counterId}`).then(resp => this.counter = resp.data)
    }
  },
  methods: {
    saveChanges: function () {
      this.$http.post("/counter/", this.counter)
          .then(() => this.$router.push({name: 'Counters'}))
          .catch(err => {
            console.error("error!!!", err.response.data)
            this.errorMessage = err.response.data.message
          })
    },
    cancelChanges: function () {
      this.$router.push({name: 'Counters'})
    },
    cancelDeletion: function () {
      this.confirmation = false
    },
    confirmDeletion: function () {
      this.confirmation = false
      this.$http.delete(`/counter/${this.counter.id}`).then(() => this.$router.push({name: 'Counters'}))
    }
  }

}
</script>